import { render, staticRenderFns } from "./dj-drawer.vue?vue&type=template&id=a84a4bee&scoped=true&"
import script from "./dj-drawer.vue?vue&type=script&lang=js&"
export * from "./dj-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84a4bee",
  null
  
)

export default component.exports